var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n  "+_vm._s(_vm.getDescriptionText(_vm.value))+"\n  "),(_vm.value.length > _vm.lengthString)?_c('button',{staticClass:"btn-link",on:{"click":function($event){_vm.seeMore = !_vm.seeMore}}},[_vm._v(_vm._s(!_vm.seeMore ? "Ver más" : "Ver menos"))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/Inputs/SeeMoreLess.vue